// @flow

import { combineReducers } from "redux";
import faceReducer from "./faceReducers";
import userReducers from "./userReducers";
import companyReducers from "./companyReducers";
import peopleReducers from "./peopleReducers";
import quoteReducers from "./quoteReducers";
import projectReducers from "./projectReducers";
import softwareReducers from "./softwareReducers";
import billingReducers from "./billingReducers";
import licenceReducers from "./licenceReducers";
import emailNotificationReducer from "./emailNotificationReducer";

const reducers = combineReducers({
  faceSearch: faceReducer,
  user: userReducers,
  company: companyReducers,
  licence: licenceReducers,
  emailNotification: emailNotificationReducer,
  db: peopleReducers,
  quote: quoteReducers,
  project: projectReducers,
  software: softwareReducers,
  billing: billingReducers
});

export default reducers;
